import Progress from 'redux-progress';

import {
  DETAILS,
  CUSTOMER_ACCOUNT_OVERVIEWS_ASYNC,
  IS_EVALUATION_ALLOWED,
  IS_RENEWABLE_ACCOUNT,
  IS_UPGRADABLE_ACCOUNT,
  ADD_CONTACT,
  VALIDATE_CONTACT,
  MAKE_CONTACT_PRIMARY,
  END_USER_CSV_DOWNLOAD_IN_PROGRESS,
  END_USER_CSV_DOWNLOAD_IS_MIGRATION_IN_PROGRESS,
} from 'modules/mac/duck/actions/accounts';
import { AccountAction, AccountData } from '../models/accounts';

export const initialState = {
  details: Progress.none,
  isUpgradableAccount: Progress.none,
  isRenewableAccount: Progress.none,
  isEvaluationAllowed: Progress.none,
  getAsyncCustomerAccountOverviewsByPartnerSearchDTO: Progress.none,
  validateContact: Progress.none,
  makeContactPrimary: Progress.none,
  endUserCSVDownloadInProgress: false,
  endUserCSVDownloadIsMigrationInProgress: false,
};

export default (state: AccountData = initialState, action: AccountAction): AccountData => {
  switch (action.type) {
    case DETAILS:
      return {
        ...state,
        newContact: undefined,
        details: { ...state.details, [action.accountId]: action.progress },
      };
    case IS_UPGRADABLE_ACCOUNT:
      return {
        ...state,
        isUpgradableAccount: { ...state.isUpgradableAccount, [action.accountId]: action.progress },
      };
    case IS_RENEWABLE_ACCOUNT:
      return {
        ...state,
        isRenewableAccount: { ...state.isRenewableAccount, [action.accountId]: action.progress },
      };
    case IS_EVALUATION_ALLOWED:
      return {
        ...state,
        isEvaluationAllowed: action.progress,
      };
    case CUSTOMER_ACCOUNT_OVERVIEWS_ASYNC:
      return {
        ...state,
        getAsyncCustomerAccountOverviewsByPartnerSearchDTO: action.progress,
      };
    case ADD_CONTACT:
      return {
        ...state,
        newContact: action.progress,
      };
    case VALIDATE_CONTACT:
      return {
        ...state,
        validateContact: action.progress,
      };
    case MAKE_CONTACT_PRIMARY:
      return {
        ...state,
        makeContactPrimary: action.progress,
      };
    case END_USER_CSV_DOWNLOAD_IN_PROGRESS:
      return {
        ...state,
        endUserCSVDownloadInProgress: action.endUserCSVDownloadInProgress,
      };
    case END_USER_CSV_DOWNLOAD_IS_MIGRATION_IN_PROGRESS:
      return {
        ...state,
        endUserCSVDownloadIsMigrationInProgress: action.endUserCSVDownloadIsMigrationInProgress,
      };
    default:
      return state;
  }
};
